import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index'
import Login from '../views/Login'
Vue.use(VueRouter)
var admin = localStorage.getItem('admin')
const routes = [{
    path: '/',
    name: 'Home',
    component: admin ? Index : Login,
    meta: { requiresAuth: true }

}, {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresNoAuth: true }
}, {
    path: '/index/:page?/:action?/:id?/:code?',
    name: 'index',
    component: Index,
    meta: { requiresAuth: true }
}]
const router = new VueRouter({
    mode: 'history',
    base: process.env.MIX_ADMIN_URL,
    routes
})


router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!admin) {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            })
        } else {
            next()
        }
    } else {
        next()
    }
    if (to.matched.some(record => record.meta.requiresNoAuth)) {
        if (admin) {
            next({
                path: '/',
                query: {
                    redirect: to.fullPath
                }
            })
        } else {
            next()
        }
    } else {
        next()
    }
})
export default router
